import React from 'react';
import { LoadingLogo } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { localizationStore } from '@stores/localization';

import 'url-search-params-polyfill';
import './customYupValidators';
// init API client interceptors
import '@api/interceptors.api';

import { Router } from './routes/Router';
import { Providers } from './providers';

export const App = observer(() => {
  if (!localizationStore.isReady) {
    return (
      <LoadingLogo className="flex h-screen flex-col items-center justify-center" />
    );
  }

  return (
    <Providers>
      <Router />
    </Providers>
  );
});

export default App;
